/* eslint-disable react/sort-comp */
import PropTypes from 'prop-types';
import React from 'react';
import Promo from '../containers/Promo';
import PromoTidal from './PromoTidal';
import PromoModal from './PromoModal';
import OnlyPrepayError from '../../components/OnlyPrepayError';
import BrokenReserveAndPayButton from './BrokenReserveAndPayButton';
import ReserveAndPayButton from './ReserveAndPayButton';
import GuardedCheckoutButton from '../containers/GuardedCheckoutButton';
import TrackClick from '../../hoc/Analytics/TrackClick';
import analytics from '../../applicationServices/analytics/BookingAnalytics';
import TidalLogo from '../../../../assets/images/promos/tidal/tidal-logo-white.svg';
import { renderTurnstileChallenge, wait } from '../../utils/helpers';
import { getFlag } from '../../../flags';

class Pay extends React.Component {
  state = {
    showPromoModal: false,
    isBookAndReserve: false,
    isTurnstileChallengeVisible: false,
  };

  constructor(props) {
    super(props);

    this.closePromoModal = this.closePromoModal.bind(this);
    this.handleReserve = this.props.handleReserve.bind(this);
    this.handleBookAndReserve = this.props.handleBookAndReserve.bind(this);
  }

  setReserveRef = ref => (this.reserveRef = ref);
  setBookAndPayRef = ref => (this.bookAndPayRef = ref);
  setReserveWithCardRef = ref => (this.reserveWithCardRef = ref);

  bookAndPay = () => {
    if (this.bookAndPayRef) {
      this.bookAndPayRef.click();
    }
  };

  onBrokenReserveConfirm = () => {
    if (this.props.isReserveWithCardAvailable && this.reserveWithCardRef) {
      this.reserveWithCardRef.click();
      return;
    }

    if (this.props.isReserveNoPayAvailable && this.reserveRef) {
      this.reserveRef.click();
    }
  };

  getVisibleElements() {
    return {
      reserve: !!this.reserveRef,
      bookAndPay: !!this.bookAndPayRef,
      reserveWithCard: !!this.reserveWithCardRef,
    };
  }

  async checkForActivePromo(isBookAndReserve = false) {
    if (!this.props.thirdPartyPromo.active) {
      if (isBookAndReserve) {
        return this.handleBookAndReserve();
      }

      const shouldRequestTurnstile = await getFlag('check-if-human');
      if (!shouldRequestTurnstile) {
        return this.handleReserve();
      }

      this.setState({ isTurnstileChallengeVisible: true });
      await wait(10); // let the container appear
      const { success, token } = await renderTurnstileChallenge('#turnstile');

      if (!success) {
        await wait(3000); // let users contemplate their browsing history for a while
        this.setState({ isTurnstileChallengeVisible: false });
        return null;
      }

      await wait(1000); // pending-to-success animation
      this.setState({ isTurnstileChallengeVisible: false });

      return this.handleReserve(token);
    }

    this.setState({ showPromoModal: true });
    return null;
  }

  closePromoModal() {
    this.setState({ showPromoModal: false });
  }

  componentDidMount() {
    analytics.buttonsActive({ ...this.getVisibleElements(), shop: this.props.shop });
  }

  render() {
    const {
      paymentEnabled,
      handleReserveAndPay,
      handleBookAndReserve,
      isKrwnZazzPlaceSteFoyShop,
      isReserveAndPayAvailable,
      isReserveWithCardAvailable,
      isReserveNoPayAvailable,
      isProcessAvailable,
      thirdPartyPromo,
      isLadyClipperShop,
      currency,
      totalAmount,
      email,
      shop,
    } = this.props;

    const allowBookAndReserve = shop.allowBookAndReserve;

    const paymentModalReserveAndPay = (
      <ReserveAndPayButton
        {...this.props}
        handleReserveAndPay={handleReserveAndPay}
        currency={currency}
        totalAmount={totalAmount}
        email={email}
        paymentEnabled={paymentEnabled}
        isLadyClipperShop={isLadyClipperShop}
        title={'I want the 2 free months, I\'ll reserve with card now'}
        showPromo={thirdPartyPromo.active}
        onBeforeClose={() => this.setState({ showPromoModal: false })}
      />
    );

    const paymentModalCustomReserve = isReserveWithCardAvailable ? (
      <TrackClick method="reserveAndPay">
        <GuardedCheckoutButton
          {...this.props}
          action="reserveAndPay"
          onSuccess={handleBookAndReserve}
          currency={currency}
          amount={totalAmount}
          email={email}
          disabled={!paymentEnabled}
          panelLabel="Reserve"
          className="c-btn c-btn--secondary delta u-1/1"
          onBeforeClose={() => this.setState({ showPromoModal: false })}
        >
          <span ref={this.setReserveWithCardRef}>
            I just want to reserve
            </span>
        </GuardedCheckoutButton>
      </TrackClick>
    ) : null;

    return (
      <div>
        <img className="is-hidden preload" src={TidalLogo} alt="PROMO" />
        {
          isReserveAndPayAvailable && !isKrwnZazzPlaceSteFoyShop && (
            <div>
              <ReserveAndPayButton
                {...this.props}
                handleReserveAndPay={handleReserveAndPay}
                currency={currency}
                totalAmount={totalAmount}
                email={email}
                paymentEnabled={paymentEnabled}
                isLadyClipperShop={isLadyClipperShop}
                showPromo={thirdPartyPromo.active}
                title={!allowBookAndReserve ? 'Reserve With Card' : undefined}
              />
              {thirdPartyPromo.active && (
                <Promo
                  title="And get 2 free months of TIDAL - a $20 value"
                  component={<PromoTidal payButton={() => (
                    <ReserveAndPayButton
                      {...this.props}
                      handleReserveAndPay={handleReserveAndPay}
                      currency={currency}
                      totalAmount={totalAmount}
                      email={email}
                      paymentEnabled={paymentEnabled}
                      isLadyClipperShop={isLadyClipperShop}
                      showPromo={thirdPartyPromo.active}
                      onBeforeClose={() => this.setState({ showPromoModal: false })}
                      title={!allowBookAndReserve ? 'Reserve With Card' : undefined}
                    />)}
                  />}
                />)}
            </div>
          )
        }
        {
          isProcessAvailable && !isKrwnZazzPlaceSteFoyShop && (
            <TrackClick method="reserveAndPay">
              <button
                className="c-btn c-btn--primary u-1/1 u-mb-"
                onClick={handleReserveAndPay}
                disabled={!paymentEnabled}
              >
                Process
              </button>
            </TrackClick>
          )
        }
        {
          isReserveAndPayAvailable && isKrwnZazzPlaceSteFoyShop && (
            <BrokenReserveAndPayButton
              disabled={!paymentEnabled}
              onConfirm={this.onBrokenReserveConfirm}
            />
          )
        }
        {
          isReserveWithCardAvailable &&
          thirdPartyPromo.active && (
            <TrackClick method="reserveAndProvideCard">
              <button
                onClick={() => this.checkForActivePromo(true)}
                className="c-btn c-btn--secondary delta u-1/1"
                disabled={!paymentEnabled}
              >
                Reserve
              </button>
            </TrackClick>
          )
        }
        {
          isReserveWithCardAvailable &&
          !thirdPartyPromo.active && (
            <TrackClick method="reserveAndPay">
              <GuardedCheckoutButton
                {...this.props}
                className="c-btn c-btn--secondary delta u-1/1"
                onSuccess={handleBookAndReserve}
                currency={currency}
                amount={totalAmount}
                email={email}
                action="reserveAndPay"
                panelLabel="Reserve"
                disabled={!paymentEnabled}
                onBeforeClose={() => this.setState({ showPromoModal: false })}
              >
                <span ref={this.setReserveWithCardRef}>
                  Reserve
                </span>
              </GuardedCheckoutButton>
            </TrackClick>
          )
        }
        {isReserveNoPayAvailable && (
          <TrackClick method="reserve">
            <button
              onClick={() => this.checkForActivePromo(false)}
              className="c-btn c-btn--secondary delta u-1/1 u-pos-relative"
              disabled={!paymentEnabled}
            >
              <span ref={this.setReserveRef}>
                Reserve
              </span>
              {
                this.state.isTurnstileChallengeVisible && (
                  <div className="c-turnstile-modal" id="turnstile" />
                )
              }
            </button>
            <OnlyPrepayError onConfirm={this.bookAndPay} />
          </TrackClick>
        )
        }
        {
          this.state.showPromoModal &&
          <PromoModal
            closeModal={this.closePromoModal}
            handleReserve={isReserveWithCardAvailable ? this.handleBookAndReserve : this.handleReserve}
            reserveAndPayButton={paymentModalReserveAndPay}
            customReserveButton={paymentModalCustomReserve}
          />
        }
      </div>
    );
  }
}

Pay.propTypes = {
  handleReserveAndPay: PropTypes.func,
  handleBookAndReserve: PropTypes.func,
  handleReserve: PropTypes.func,
  paymentEnabled: PropTypes.bool,
  isKrwnZazzPlaceSteFoyShop: PropTypes.bool.isRequired,
  isReserveAndPayAvailable: PropTypes.bool,
  isReserveWithCardAvailable: PropTypes.bool,
  isReserveNoPayAvailable: PropTypes.bool,
  isLadyClipperShop: PropTypes.bool.isRequired,
  isProcessAvailable: PropTypes.bool,
  thirdPartyPromo: PropTypes.shape({ active: PropTypes.bool }),
  shop: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  email: PropTypes.string,
  totalAmount: PropTypes.number,
  currency: PropTypes.string.isRequired,
};

Pay.defaultProps = {
  handleReserveAndPay: null,
  handleBookAndReserve: null,
  handleReserve: null,
  paymentEnabled: false,
  isReserveAndPayAvailable: false,
  isReserveWithCardAvailable: false,
  isReserveNoPayAvailable: false,
  isProcessAvailable: false,
  thirdPartyPromo: { active: false },
  totalAmount: 0,
  email: '',
};

export default Pay;



// WEBPACK FOOTER //
// ./src/app/reservation/components/Pay.jsx